import React, { useState, useEffect } from 'react';
import Footer from '../../Components/Footer/Footer';
import './Reviews.css';
import HomeNav from '../../Components/Navbar/NewNavbar';
import Loading1 from '../../Components/Loading/Loading1';

function Reviews() {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 900);
    }, []);

    const reviews = [
        {
            id: 1,
            name: "Priya Sharma",
            title: "Outstanding Service!",
            text: "Astra Clean exceeded my expectations. The team arrived on time, worked efficiently, and left my home spotless. Everything smelled fresh and looked amazing. Highly recommended!",
            rating: 5
        },
        {
            id: 2,
            name: "Rajesh Kumar",
            title: "Reliable and Professional",
            text: "I've tried several cleaning services, but Astra Clean stands out. Their attention to detail and professionalism is unmatched. My office has never looked better.",
            rating: 5
        },
        {
            id: 3,
            name: "Anjali Patel",
            title: "Perfect for Busy Schedules",
            text: "Booking was quick and easy, and I loved the flexible scheduling. The cleaners were friendly, respectful, and did an excellent job. I'll definitely be using Astra Clean again.",
            rating: 5
        },
        {
            id: 4,
            name: "Vikram Singh",
            title: "Top-Notch Cleaning Quality",
            text: "From start to finish, the service was excellent. Every corner was cleaned perfectly, and they handled my belongings with great care. Truly a 5-star experience.",
            rating: 5
        },
        {
            id: 5,
            name: "Meera Reddy",
            title: "Great Value for Money",
            text: "Astra Clean offers high-quality service at a fair price. The results were impressive, and the team was very professional. I'm extremely satisfied.",
            rating: 5
        },
        {
            id: 6,
            name: "Arjun Desai",
            title: "Highly Trustworthy Team",
            text: "I felt completely comfortable having Astra Clean in my home. The staff was polite, well-trained, and very thorough. I couldn't ask for more.",
            rating: 5
        },
        {
            id: 7,
            name: "Kavita Nair",
            title: "Excellent Customer Support",
            text: "Not only was the cleaning fantastic, but their customer support was also very responsive and helpful. They really care about customer satisfaction.",
            rating: 5
        },
        {
            id: 8,
            name: "Suresh Iyer",
            title: "Fresh, Clean, and Inviting",
            text: "After Astra Clean's service, my space felt brand new. Clean, fresh, and welcoming. I recommend them to anyone looking for reliable cleaning services.",
            rating: 5
        },
        {
            id: 9,
            name: "Divya Joshi",
            title: "Dependable and Consistent",
            text: "I use Astra Clean regularly, and they always deliver consistent, high-quality results. It's great to have a cleaning service you can truly rely on.",
            rating: 5
        },
        {
            id: 10,
            name: "Amit Verma",
            title: "Simply the Best Cleaning Service",
            text: "Professional, efficient, and detail-oriented. Astra Clean is hands down the best cleaning service I've used.",
            rating: 5
        }
    ];

    const renderStars = (rating) => {
        return Array.from({ length: 5 }, (_, index) => (
            <span key={index} className={`star ${index < rating ? 'star-filled' : 'star-empty'}`}>
                ★
            </span>
        ));
    };

    const getInitials = (name) => {
        return name.split(' ').map(n => n[0]).join('').toUpperCase();
    };

    if (isLoading) {
        return <Loading1 />;
    }

    return (
        <>
            <HomeNav />
            <div className="reviews-container">
                <h2 className="reviews-title">Customer Reviews – Astra Clean</h2>
                <p className="reviews-intro">
                    See what our customers have to say about their experience with <strong>Astra Clean</strong>. 
                    We're proud of the trust and satisfaction our clients have shown us.
                </p>
                <div className="reviews-grid">
                    {reviews.map((review) => (
                        <div key={review.id} className="review-card">
                            <div className="review-header">
                                <div className="review-avatar">
                                    {getInitials(review.name)}
                                </div>
                                <div className="review-header-info">
                                    <h3 className="review-name">{review.name}</h3>
                                    <div className="review-rating">{renderStars(review.rating)}</div>
                                </div>
                            </div>
                            <h4 className="review-title">{review.title}</h4>
                            <p className="review-text">{review.text}</p>
                            <div className="review-quote-icon">"</div>
                        </div>
                    ))}
                </div>
            </div>
            <Footer />
        </>
    );
}

export default Reviews;
